__turbopack_context__.v({
  "layout": "c1L6SG_layout",
  "list": "c1L6SG_list",
  "nav": "c1L6SG_nav",
  "navItem": "c1L6SG_navItem",
  "navItemActive": "c1L6SG_navItemActive",
});
